import Amplify, {Auth} from 'aws-amplify';
import stageParameters from "./constants/env";
import {getDomain} from "./utils/cookie";

const baseUrl = window.location.origin;


const configureAuthClient = (stage: string, isViaForSchools = false,
                       cognitoUserPool = "", cognitoAppClientID = "") => {
    const parameters = stageParameters[stage];
    const configuration = {
        region: parameters.region,
        userPoolId: cognitoUserPool || parameters.userPoolId,
        userPoolWebClientId: cognitoAppClientID || parameters.cognitoClientId,
        oauth: {
            domain: parameters.cognitoDomainName,
            scope: ['email', 'openid', 'profile'],
            redirectSignIn: baseUrl,
            redirectSignOut: baseUrl,
            responseType: 'code',
        },
        cookieStorage: {
            domain: getDomain(parameters.cookieDomainName, stage, window.location.hostname),
            path: '/',
            expires: 1,
            secure: parameters.secureCookie
        },
    };
    Amplify.configure({Auth: configuration});
    Auth.configure(configuration);

};

export {configureAuthClient};

